import React from 'react'
import { observer } from 'mobx-react'

import BookkeepingManagerViewModel from 'admin/bookkeeping/BookkeepingManagerViewModel'

import styles from './BookkeepingManagerTableTotal.sass'

interface BookkeepingManagerTableTotalProps {
  vm: BookkeepingManagerViewModel
}

export default observer(function BookkeepingManagerTableTotal({
  vm,
}: BookkeepingManagerTableTotalProps) {
  const total = vm.filteredItems.length

  return (
    <div className={styles.container}>
      Accounts
      <span className={styles.total}>({total ?? 0})</span>
    </div>
  )
})
